export default __webpack_public_path__ + "static/media/SwampHacks.0feaf36f.svg";